import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faSliders, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import WhatsAppControl from '../../components/WhatsAppControl';
import WhatsAppAnnouncements from '../../components/WhatsAppAnnouncements';
import WhatsAppNotificationSettings from '../../components/WhatsAppNotificationSettings';
import '../../styles/App.css';
import '../../styles/whatsapp.css';

/**
 * Its own page rather than a card inside System Configuration.
 *
 * Everything else on that page is a stored preference — shift times, leave
 * thresholds — set once and rarely revisited. This is the opposite: a live
 * service that can be broken right now and needs acting on. Burying a red
 * light three cards down a settings page is how a 20-hour outage goes
 * unnoticed.
 *
 * Three tabs rather than three stacked cards: Connection, Notifications and
 * Announcements each grew into their own scrollful, and none of them needs
 * to be visible while working in another — nobody links a phone and reviews
 * notification categories in the same glance.
 */
const TABS = [
    { key: 'connection', label: 'Connection', icon: faCommentDots },
    { key: 'notifications', label: 'Notifications', icon: faSliders },
    { key: 'announcements', label: 'Announcements', icon: faBullhorn }
];

const WhatsAppAdmin = () => {
    const [tab, setTab] = useState('connection');

    return (
        <div className="attendance-container fade-in" style={{ paddingBottom: '40px' }}>
            <h1 className="page-title">
                <FontAwesomeIcon icon={faCommentDots} style={{ marginRight: '10px', color: 'light-dark(#25D366, var(--theme-success-ink, #7bcf9f))' }} />
                WhatsApp
            </h1>
            <p className="text-muted" style={{ marginTop: '-6px', marginBottom: '20px' }}>
                Connection status, linking, a live test, which notifications go out, and company-wide announcements.
            </p>

            <div className="wa-tabs">
                {TABS.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        className={`wa-tab ${tab === t.key ? 'is-on' : ''}`}
                        onClick={() => setTab(t.key)}
                    >
                        <FontAwesomeIcon icon={t.icon} /> {t.label}
                    </button>
                ))}
            </div>

            {tab === 'connection' && <WhatsAppControl />}
            {tab === 'notifications' && <WhatsAppNotificationSettings />}
            {tab === 'announcements' && <WhatsAppAnnouncements />}
        </div>
    );
};

export default WhatsAppAdmin;
